// extracted by mini-css-extract-plugin
module.exports = {"container":"Checkout--container--3phoz"};